import { motion, useScroll, useTransform } from 'framer-motion';

const HeroSection = () => {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 500], [0, 150]);

  return (
    <div className="hero-section-wrapper">
      <motion.section
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
        className="relative w-full h-screen overflow-hidden"
        data-testid="hero-reveal-section"
      >
        <motion.div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_tss-admission-portal/artifacts/amfoownn_Screenshot%202026-04-14%20at%205.47.09%E2%80%AFAM.jpg)',
            scale: 1.2,
            y
          }}
        />
        <div className="absolute inset-0 hero-overlay" />
        <div className="letterbox-bar letterbox-bar-top" />
        <div className="letterbox-bar letterbox-bar-bottom" />
        
        <div className="relative h-full flex items-end justify-center pb-16 sm:pb-24 px-6 sm:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 1.2 }}
            className="max-w-4xl text-center"
          >
            <p 
              className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight"
              style={{ fontFamily: 'EB Garamond, serif', color: '#f0ebe0' }}
            >
              Cinema in this country comes from everywhere.<br/>
              We've built its newest seat in the heart of the Deccan.
            </p>
            <p 
              className="text-[11px] sm:text-sm mt-6 font-mono tracking-[0.1em] uppercase opacity-55"
              style={{ color: '#f0ebe0' }}
            >
              A conversation space at the intersection of cinema and culture
            </p>
          </motion.div>
        </div>
      </motion.section>
    </div>
  );
};

export default HeroSection;
